import { useEffect, useState } from 'react';

import { Button, Row, Text } from '@opendoor/bricks-next';

import styles from './StickyCTAUtility.module.css';

const ANIMATION_DURATION = 0.7;

interface StickyCTAUtilityProps {
  isVisible: boolean;
  analyticsId: string;
  top?: string;
}

export const StickyCTAUtility = ({ isVisible, analyticsId, top = '2%' }: StickyCTAUtilityProps) => {
  const [showStickyCTAUtility, setShowStickyCTAUtility] = useState(false);
  const [animate, setAnimate] = useState<string | undefined>(undefined);

  useEffect(() => {
    setAnimate(isVisible ? styles.reveal : styles.hide);

    if (isVisible) {
      setShowStickyCTAUtility(true);
    }

    setTimeout(() => {
      setAnimate(undefined);

      if (!isVisible) {
        setShowStickyCTAUtility(false);
      }
    }, ANIMATION_DURATION * 1000);
  }, [isVisible]);

  return (
    <Row
      display={showStickyCTAUtility ? 'flex' : 'none'}
      className={`${styles.container}${animate ? ` ${animate}` : ''}`}
      $platform-web={{ position: 'fixed', top }}
      zIndex={9999}
      mx="auto"
      width="$75"
      $largerThanSM={{ width: '$90' }}
      justifyContent="space-between"
      alignItems="center"
      p="$1half"
      borderRadius="$10x"
    >
      <Text tag="p" typography="$labelXlarge" px="$4" $largerThanSM={{ px: '$5' }}>
        Still selling?
      </Text>
      <Button
        maxWidth="$35"
        $largerThanLG={{ maxWidth: '$40' }}
        onPress={() => window.location.assign('/address-entry')}
        aria-label="sticky CTA utility"
        analyticsName={`cosmos-landing-page-sticky-cta-${analyticsId}`}
        variant="primary"
        size="xsmall"
        label="Get cash offer"
        minHeight="$4"
        $largerThanMD={{ minHeight: '$13' }}
      />
    </Row>
  );
};
